import React from 'react';
import { Row, Col, Table } from 'react-bootstrap';
import { 
    GIOI_TINH, 
    HOC_VI, 
    CHUC_DANH_KH, 
    VAI_TRO_BAI_BAO, 
    LOAI_TAP_CHI, 
    VAI_TRO_DE_TAI, 
    CAP_DE_TAI, 
    XEP_LOAI_KET_QUA, 
    VAI_TRO_SANG_CHE, 
    CAP_GIAI_THUONG, 
    LOAI_SACH, 
    VAI_TRO_SACH, 
    BAC_HOC_VIEN, 
    TRACH_NHIEM_HD 
} from '@app/utils/define';
import { formatDateTimeWithoutHour } from '@app/utils/helper';

const PrintLayoutV1 = ({
    nhanVien = {},
    tenDonVi = '',
    baiBao = [],
    deTai = [],
    sangChe = [],
    giaiThuong = [],
    sach = [],
    huongDanHocVien = [],
    giaiThuongDaoTao = []
}) => {
    return (
        <div className="d-none d-print-block print-layout-v1-wrapper">
            <table className="print-layout-table">
                <thead>
                    <tr>
                        <td>
                            <div style={{ height: '2.5cm' }}></div>
                        </td>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td className="print-layout-content-cell">
                            {/* HEADER IN ẤN */}
            <div className="print-header">
                <div className="text-center mb-5">
                    <h5 className="font-weight-bold text-uppercase mb-1" style={{ fontSize: '13pt' }}>CỘNG HÒA XÃ HỘI CHỦ NGHĨA VIỆT NAM</h5>
                    <h6 className="font-weight-bold mb-4" style={{ fontSize: '12pt' }}>Độc lập - Tự do - Hạnh phúc</h6>
                    
                    <h4 className="mt-5 font-weight-bold text-uppercase" style={{ fontSize: '16pt' }}>LÝ LỊCH KHOA HỌC</h4>
                    <div className="font-italic mb-4" style={{ fontSize: '11pt', lineHeight: '1.5' }}>
                        (Dành cho giảng viên<br />
                        của Viện Nghiên cứu Khoa học Y Dược lâm sàng 108)
                    </div>
                </div>

                {/* THÔNG TIN LÝ LỊCH CÁ NHÂN KHI IN */}
                <div className="personal-print-info mb-4">
                    <h5 className="font-weight-bold mb-3" style={{ fontSize: '12pt' }}>1. Thông tin cá nhân</h5>
                    <table className="w-100 table-print-details">
                        <tbody>
                            <tr>
                                <td style={{ width: '50%' }}><strong>1. Họ và tên:</strong> {nhanVien.hoTen}</td>
                                <td><strong>2. Ngày sinh:</strong> {formatDateTimeWithoutHour(nhanVien.ngaySinh)}</td>
                            </tr>
                            <tr>
                                <td><strong>3. Giới tính:</strong> {GIOI_TINH.find(o => o.value === nhanVien.gioiTinh)?.label || 'Chưa cập nhật'}</td>
                                <td><strong>4. Chức vụ:</strong> {nhanVien.chucVu || 'Chưa cập nhật'}</td>
                            </tr>
                            <tr>
                                <td><strong>5. Đơn vị công tác:</strong> {tenDonVi || nhanVien.tenDonViTuNhap || 'Chưa rõ'}</td>
                                <td><strong>6. Học vị cao nhất:</strong> {HOC_VI.find(o => o.value === nhanVien.hocViCaoNhat)?.label || nhanVien.hocViCaoNhat}</td>
                            </tr>
                            <tr>
                                <td><strong>7. Chức danh khoa học:</strong> {CHUC_DANH_KH.find(o => o.value === nhanVien.chucDanhKHCaoNhat)?.label || 'Không'}</td>
                                <td><strong>8. Điện thoại di động:</strong> {nhanVien.dienThoaiDiDong || 'Chưa cập nhật'}</td>
                            </tr>
                            <tr>
                                <td colSpan={2}><strong>9. Email công việc:</strong> {nhanVien.emailCongViec || 'Chưa cập nhật'}</td>
                            </tr>
                            {nhanVien.thongTinIdent && (
                                <tr>
                                    <td colSpan={2}><strong>10. Chỉ số định danh (ORCID, Google Scholar...):</strong> {nhanVien.thongTinIdent}</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>

            {/* IN ẤN TOÀN BỘ CV - PHẦN II & PHẦN III */}
            <div className="mt-4 print-achievements-container">
                {/* 2.1. Bài báo khoa học đã công bố */}
                <div className="mb-4">
                    <div className="font-weight-bold font-italic mb-3" style={{ fontSize: '12pt' }}>
                        2.1. Bài báo khoa học đã công bố (tên bài báo, tên tạp chí, số, năm công bố, vai trò):
                    </div>
                    <Table striped bordered hover responsive>
                        <thead className="bg-light">
                            <tr>
                                <th>TT</th>
                                <th>Tên bài báo/báo cáo KH</th>
                                <th>Số tác giả</th>
                                <th>Là tác giả (chính/liên hệ/phụ)</th>
                                <th>Tên tạp chí hoặc kỷ yếu khoa học/ ISSN hoặc ISBN</th>
                                <th>Loại Tạp chí quốc tế uy tín: ISI, Scopus (IF, Qi)</th>
                                <th>Số lần trích dẫn (không tính tự trích dẫn)</th>
                                <th>Tập, số, trang</th>
                                <th>Tháng, năm công bố</th>
                            </tr>
                        </thead>
                        <tbody>
                            {baiBao.map((b, idx) => (
                                <tr key={b.id}>
                                    <td>{idx + 1}</td>
                                    <td><strong>{b.tenBaiBao}</strong></td>
                                    <td>{b.soTacGia}</td>
                                    <td>
                                        {(() => {
                                            const val = b.vaiTroTacGia;
                                            if (val === 1 || val === '1') return 'Chính';
                                            if (val === 2 || val === '2') return 'Liên hệ';
                                            if (val === 3 || val === '3') return 'Phụ';
                                            const found = VAI_TRO_BAI_BAO.find(o => o.value === val);
                                            if (found) {
                                                if (found.label.includes('chính')) return 'Chính';
                                                if (found.label.includes('liên hệ')) return 'Liên hệ';
                                                if (found.label.includes('phụ') || found.label.includes('Đồng tác giả')) return 'Phụ';
                                            }
                                            return val || 'Phụ';
                                        })()}
                                    </td>
                                    <td>
                                        {b.tenTapChi}
                                        {b.issnIsbn && ` (ISSN: ${b.issnIsbn})`}
                                    </td>
                                    <td>
                                        {(() => {
                                            const val = b.loaiTapChi;
                                            const v = Number(val);
                                            if (v === 1) return 'Bài báo trên tạp chí ISI/Scopus uy tín (Q1/Q2)';
                                            if (v === 2) return 'Bài báo trên tạp chí quốc tế uy tín khác (Q3/Q4)';
                                            if (v === 3) return 'Bài báo trên tạp chí quốc tế khác';
                                            if (v === 4) return 'Bài báo trên tạp chí khoa học quốc gia uy tín';
                                            if (v === 5) return 'Bài báo trên các tạp chí khoa học quốc gia uy tín';
                                            const found = LOAI_TAP_CHI.find(o => o.value === val);
                                            return found ? found.label : val;
                                        })()}
                                    </td>
                                    <td>{b.soLanTrichDan !== null && b.soLanTrichDan !== undefined ? b.soLanTrichDan : 0}</td>
                                    <td>{b.tapSoTrang || ''}</td>
                                    <td>{b.nam}</td>
                                </tr>
                            ))}
                            {baiBao.length === 0 && (
                                <tr>
                                    <td colSpan={9} className="text-center text-muted">Không có bài báo khoa học nào</td>
                                </tr>
                            )}
                        </tbody>
                    </Table>
                </div>

                {/* 2.2. Các nhiệm vụ khoa học và công nghệ */}
                <div className="mb-4">
                    <div className="font-weight-bold font-italic mb-3" style={{ fontSize: '12pt' }}>
                        2.2. Các nhiệm vụ khoa học và công nghệ (chương trình và đề tài các cấp):
                    </div>
                    <Table striped bordered hover responsive>
                        <thead className="bg-light">
                            <tr>
                                <th>TT</th>
                                <th>Tên nhiệm vụ khoa học và công nghệ (CT, ĐT...)</th>
                                <th>CN/PCN/TK</th>
                                <th>Mã số và cấp quản lý</th>
                                <th>Thời gian thực hiện</th>
                                <th>Thời gian nghiệm thu (ngày, tháng, năm)/Xếp loại KQ</th>
                            </tr>
                        </thead>
                        <tbody>
                            {deTai.map((d, idx) => (
                                <tr key={d.id}>
                                    <td>{idx + 1}</td>
                                    <td><strong>{d.tenNhiemVu}</strong></td>
                                    <td>
                                        {(() => {
                                            const val = d.vaiTro;
                                            if (val === 1 || val === '1') return 'CN';
                                            if (val === 2 || val === '2') return 'PCN';
                                            if (val === 3 || val === '3') return 'TK';
                                            if (val === 4 || val === '4') return 'TV';
                                            const found = VAI_TRO_DE_TAI.find(o => o.value === val);
                                            if (found) {
                                                if (found.label.includes('Chủ nhiệm')) return 'CN';
                                                if (found.label.includes('Phó chủ nhiệm')) return 'PCN';
                                                if (found.label.includes('Thư ký')) return 'TK';
                                                if (found.label.includes('Thành viên')) return 'TV';
                                            }
                                            return val;
                                        })()}
                                    </td>
                                    <td>{CAP_DE_TAI.find(o => o.value === d.maSoCapQuanLy)?.label || d.maSoCapQuanLy}</td>
                                    <td>
                                        {(() => {
                                            if (!d.thoiGianTuNgay) return '';
                                            const fTu = formatDateTimeWithoutHour(d.thoiGianTuNgay);
                                            const fDen = d.thoiGianDenNgay ? formatDateTimeWithoutHour(d.thoiGianDenNgay) : '';
                                            const getDisplay = (dateStr) => {
                                                if (!dateStr) return '';
                                                const parts = dateStr.split('/');
                                                if (parts.length === 3) {
                                                    if (parts[0] === '01' && parts[1] === '01') return parts[2];
                                                    return `${parts[1]}/${parts[2]}`;
                                                }
                                                return dateStr;
                                            };
                                            const tuDisplay = getDisplay(fTu);
                                            const denDisplay = getDisplay(fDen);
                                            return denDisplay ? `${tuDisplay} - ${denDisplay}` : tuDisplay;
                                        })()}
                                    </td>
                                    <td>
                                        {d.thoiGianNghiemThu && <div>{formatDateTimeWithoutHour(d.thoiGianNghiemThu)}</div>}
                                        <div>
                                            {(() => {
                                                const val = d.xepLoaiKetQua;
                                                if (val === 1 || val === '1') return 'Xuất sắc';
                                                const found = XEP_LOAI_KET_QUA.find(o => o.value === val);
                                                return found ? found.label : (val || 'Chưa nghiệm thu');
                                            })()}
                                        </div>
                                    </td>
                                </tr>
                            ))}
                            {deTai.length === 0 && (
                                <tr>
                                    <td colSpan={6} className="text-center text-muted">Không có đề tài nghiên cứu nào</td>
                                </tr>
                            )}
                        </tbody>
                    </Table>
                    <div className="mt-2" style={{ fontSize: '11pt', fontStyle: 'italic' }}>
                        - Các chữ viết tắt: CT: Chương trình; ĐT: Đề tài; CN: Chủ nhiệm; PCN: Phó chủ nhiệm; TK: Thư ký.
                    </div>
                </div>

                {/* 2.3. Bằng độc quyền sáng chế & giải pháp hữu ích */}
                <div className="mb-4">
                    <div className="font-weight-bold font-italic mb-3" style={{ fontSize: '12pt' }}>
                        2.3. Bằng độc quyền sáng chế & giải pháp hữu ích (nếu có):
                    </div>
                    <Table striped bordered hover responsive>
                        <thead className="bg-light">
                            <tr>
                                <th>TT</th>
                                <th>Tên bằng sáng chế / GPHU</th>
                                <th>Cơ quan cấp</th>
                                <th>Ngày cấp</th>
                                <th>Vai trò sáng chế</th>
                                <th>Số tác giả</th>
                            </tr>
                        </thead>
                        <tbody>
                            {sangChe.map((s, idx) => (
                                <tr key={s.id}>
                                    <td>{idx + 1}</td>
                                    <td><strong>{s.tenBangSangChe}</strong></td>
                                    <td>{s.tenCoQuanCap}</td>
                                    <td>{formatDateTimeWithoutHour(s.ngayThangNamCap)}</td>
                                    <td>{VAI_TRO_SANG_CHE.find(o => o.value === s.vaiTroTacGia)?.label || s.vaiTroTacGia}</td>
                                    <td>{s.soTacGia}</td>
                                </tr>
                            ))}
                            {sangChe.length === 0 && (
                                <tr>
                                    <td colSpan={6} className="text-center text-muted">Không có sáng chế / giải pháp hữu ích nào</td>
                                </tr>
                            )}
                        </tbody>
                    </Table>
                </div>

                {/* 2.4. Các giải thưởng nghiên cứu khoa học */}
                <div className="mb-4">
                    <div className="font-weight-bold font-italic mb-3" style={{ fontSize: '12pt' }}>
                        2.4. Các giải thưởng nghiên cứu khoa học (nếu có):
                    </div>
                    <Table striped bordered hover responsive>
                        <thead className="bg-light">
                            <tr>
                                <th>TT</th>
                                <th>Giải thưởng khoa học công nghệ</th>
                                <th>Năm nhận</th>
                                <th>Cấp công nhận</th>
                            </tr>
                        </thead>
                        <tbody>
                            {giaiThuong.map((g, idx) => (
                                <tr key={g.id}>
                                    <td>{idx + 1}</td>
                                    <td><strong>{g.hinhThucVaNoiDung}</strong></td>
                                    <td>{g.namTangThuong}</td>
                                    <td>{CAP_GIAI_THUONG.find(o => o.value === g.capCongNhan)?.label || g.capCongNhan}</td>
                                </tr>
                            ))}
                            {giaiThuong.length === 0 && (
                                <tr>
                                    <td colSpan={4} className="text-center text-muted">Không có giải thưởng NCKH nào</td>
                                </tr>
                            )}
                        </tbody>
                    </Table>
                </div>

                {/* 3.1. Sách chuyên khảo, giáo trình */}
                <div className="mb-4">
                    <div className="font-weight-bold font-italic mb-3" style={{ fontSize: '12pt' }}>
                        3.1. Sách và giáo trình đã xuất bản (tên sách, vai trò, nhà xuất bản, năm xuất bản):
                    </div>
                    <Table striped bordered hover responsive>
                        <thead className="bg-light">
                            <tr>
                                <th>TT</th>
                                <th>Tên sách</th>
                                <th>Nhà xuất bản</th>
                                <th>Phân loại sách</th>
                                <th>Năm xuất bản</th>
                                <th>Vai trò biên soạn</th>
                                <th>Số chương biên soạn</th>
                                <th>Phần viết (Trang)</th>
                            </tr>
                        </thead>
                        <tbody>
                            {sach.map((s, idx) => (
                                <tr key={s.id}>
                                    <td>{idx + 1}</td>
                                    <td><strong>{s.tenSach}</strong></td>
                                    <td>{s.nhaXuatBan}</td>
                                    <td>{LOAI_SACH.find(o => o.value === s.loaiSach)?.label || s.loaiSach}</td>
                                    <td>{s.namXuatBan}</td>
                                    <td>{VAI_TRO_SACH.find(o => o.value === s.vaiTro)?.label || s.vaiTro} ({s.soTacGia} tác giả)</td>
                                    <td>{s.soChuongSach || '-'}</td>
                                    <td>Trang {s.phanBienSoanTuTrang} - {s.phanBienSoanDenTrang}</td>
                                </tr>
                            ))}
                            {sach.length === 0 && (
                                <tr>
                                    <td colSpan={7} className="text-center text-muted">Không có sách / giáo trình nào</td>
                                </tr>
                            )}
                        </tbody>
                    </Table>
                </div>

                {/* 3.2. Hướng dẫn học viên */}
                <div className="mb-4">
                    <div className="font-weight-bold font-italic mb-3" style={{ fontSize: '12pt' }}>
                        3.2. Hướng dẫn học viên nghiên cứu sinh, thạc sĩ, nội trú:
                    </div>
                    <Table striped bordered hover responsive>
                        <thead className="bg-light">
                            <tr>
                                <th>TT</th>
                                <th>Học viên</th>
                                <th>Bậc học viên</th>
                                <th>Tên đề tài luận văn/luận án</th>
                                <th>Cơ sở đào tạo</th>
                                <th>Trách nhiệm HD</th>
                                <th>Thời điểm bảo vệ</th>
                                <th>Thời gian hướng dẫn</th>
                                <th>Thời gian đào tạo (QĐ)</th>
                            </tr>
                        </thead>
                        <tbody>
                            {huongDanHocVien.map((h, idx) => (
                                <tr key={h.id}>
                                    <td>{idx + 1}</td>
                                    <td><strong>{h.hoTenHocVien}</strong></td>
                                    <td>{BAC_HOC_VIEN.find(o => o.value === h.doiTuong)?.label || h.doiTuong}</td>
                                    <td>{h.tenDeTai}</td>
                                    <td>{h.coSoDaoTao}</td>
                                    <td>{TRACH_NHIEM_HD.find(o => o.value === h.trachNhiemHuongDan)?.label || h.trachNhiemHuongDan}</td>
                                    <td>{h.thoiDiemBaoVe || '-'}</td>
                                    <td>{h.thoiGianHuongDanTu && h.thoiGianHuongDanDen ? `${formatDateTimeWithoutHour(h.thoiGianHuongDanTu)} - ${formatDateTimeWithoutHour(h.thoiGianHuongDanDen)}` : '-'}</td>
                                    <td>{h.thoiGianDaoTaoTu && h.thoiGianDaoTaoDen ? `${formatDateTimeWithoutHour(h.thoiGianDaoTaoTu)} - ${formatDateTimeWithoutHour(h.thoiGianDaoTaoDen)}` : '-'}</td>
                                </tr>
                            ))}
                            {huongDanHocVien.length === 0 && (
                                <tr>
                                    <td colSpan={8} className="text-center text-muted">Không có dữ liệu hướng dẫn học viên</td>
                                </tr>
                            )}
                        </tbody>
                    </Table>
                </div>

                {/* 3.3. Giải thưởng về đào tạo */}
                <div className="mb-4">
                    <div className="font-weight-bold font-italic mb-3" style={{ fontSize: '12pt' }}>
                        3.3. Giải thưởng về đào tạo (nếu có):
                    </div>
                    {giaiThuongDaoTao.length > 0 ? (
                        <div style={{ paddingLeft: '15px' }}>
                            {giaiThuongDaoTao.map((g, idx) => (
                                <div key={g.id} className="mb-2" style={{ fontSize: '11pt', lineHeight: '1.6' }}>
                                    <strong>{idx + 1}.</strong> {g.tenGiaiThuong}, Năm: {g.namTangThuong}
                                </div>
                            ))}
                        </div>
                    ) : (
                        <div className="font-italic" style={{ paddingLeft: '15px', fontSize: '11pt' }}>Không có</div>
                    )}
                </div>
            </div>

            {/* THÔNG TIN BIO KHI IN */}
            <div className="print-bio-section mt-4">
                {nhanVien.gioiThieuChung && (
                    <div className="mb-3">
                        <h6 className="font-weight-bold">II. Giới thiệu chung:</h6>
                        <div dangerouslySetInnerHTML={{ __html: nhanVien.gioiThieuChung }} />
                    </div>
                )}
                {nhanVien.chuyenNganhLinhVuc && (
                    <div className="mb-3">
                        <h6 className="font-weight-bold">III. Chuyên ngành & thế mạnh chuyên môn:</h6>
                        <div dangerouslySetInnerHTML={{ __html: nhanVien.chuyenNganhLinhVuc }} />
                    </div>
                )}
                {nhanVien.kinhNghiemLamViec && (
                    <div className="mb-3">
                        <h6 className="font-weight-bold">IV. Kinh nghiệm làm việc:</h6>
                        <div dangerouslySetInnerHTML={{ __html: nhanVien.kinhNghiemLamViec }} />
                    </div>
                )}
                {nhanVien.congTrinhNBXB && (
                    <div className="mb-3">
                        <h6 className="font-weight-bold">V. Công trình nghiên cứu, xuất bản và đào tạo:</h6>
                        <div dangerouslySetInnerHTML={{ __html: nhanVien.congTrinhNBXB }} />
                    </div>
                )}
                {nhanVien.thanhVienHoiNghe && (
                    <div className="mb-3">
                        <h6 className="font-weight-bold">VI. Thành viên Hội nghề nghiệp:</h6>
                        <div dangerouslySetInnerHTML={{ __html: nhanVien.thanhVienHoiNghe }} />
                    </div>
                )}
                {nhanVien.giaiThuongDanhHieu && (
                    <div className="mb-3">
                        <h6 className="font-weight-bold">VII. Giải thưởng và danh hiệu:</h6>
                        <div dangerouslySetInnerHTML={{ __html: nhanVien.giaiThuongDanhHieu }} />
                    </div>
                )}

                {/* CAM ĐOAN KHI IN */}
                <div className="mt-5 mb-5" style={{ fontSize: '11pt', fontStyle: 'italic', textAlign: 'left' }}>
                    Tôi xin cam đoan những điều khai trên là đúng sự thật, nếu sai tôi xin hoàn toàn chịu trách nhiệm trước pháp luật.
                </div>

                {/* CHỮ KÝ CHÂN TRANG KHI IN */}
                <div className="mt-5 print-signature-section" style={{ fontSize: '12pt', pageBreakInside: 'avoid' }}>
                    <Row>
                        <Col xs={6} className="text-center">
                            <div className="font-weight-bold text-uppercase" style={{ fontSize: '12pt' }}>XÁC NHẬN CỦA CHỈ HUY ĐƠN VỊ</div>
                        </Col>
                        <Col xs={6} className="text-center">
                            <div className="font-italic">
                                Hà Nội, Ngày {String(new Date().getDate()).padStart(2, '0')} tháng {String(new Date().getMonth() + 1).padStart(2, '0')} năm {new Date().getFullYear()}
                            </div>
                            <div className="font-weight-bold text-uppercase mt-2" style={{ fontSize: '12pt' }}>NGƯỜI KHAI</div>
                            <div style={{ height: '100px' }}></div>
                            <div className="font-weight-bold" style={{ fontSize: '12pt' }}>{nhanVien.hoTen}</div>
                        </Col>
                    </Row>
                </div>
            </div>
                        </td>
                    </tr>
                </tbody>
                <tfoot>
                    <tr>
                        <td>
                            <div style={{ height: '2.5cm' }}></div>
                        </td>
                    </tr>
                </tfoot>
            </table>
        </div>
    );
};

export default PrintLayoutV1;
